import Swiper, { Navigation, Pagination, Lazy, Autoplay, Controller } from 'swiper';

const swiperStart = new Swiper('.swiper--start', {
  modules: [ Navigation, Lazy, Autoplay ],
  speed: 600,
  slidesPerView: 1,
  spaceBetween: 0,
  // allowTouchMove: false,
  // focusableElements: 'a, input, select, option, textarea, button, video, label',
  loop: true,
  navigation: {
    nextEl: '.swiper-nav--start--next',
    prevEl: '.swiper-nav--start--prev',
    disabledClass: 'is-disabled',
  },
  lazy: {
    enabled: true,
    loadOnTransitionStart: true,
    loadPrevNext: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 4,
    },
  }
  // on: {
  //   slideChange: function() {
  //     swiperPreventFocus(this.slides, this.activeIndex, this.previousIndex);
  //   },
  // }
});
// function swiperPreventFocus(slides, currIndex, prevIndex) {
//   slides.forEach((slide, index) => {
//     let focusableElements = slide.querySelectorAll('a, button');
//     if (index == currIndex) {
//       focusableElements.forEach(element => {
//         element.removeAttribute('tabIndex');
//       });
//     }
//     else {
//       focusableElements.forEach(element => {
//         element.setAttribute('tabIndex', -1);
//       });
//     }
//   })
// }

const flexibleSwipers = document.querySelectorAll('.swiper--flexible');
flexibleSwipers.forEach(flexibleSwiper => {
  new Swiper(flexibleSwiper, {
    modules: [ Navigation, Lazy, Autoplay ],
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    // loop: true,
    navigation: {
      nextEl: '.swiper-nav--start--next',
      prevEl: '.swiper-nav--start--prev',
      disabledClass: 'is-disabled',
    },
    lazy: {
      enabled: true,
      loadOnTransitionStart: true,
      loadPrevNext: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 4,
      },
    }
  });
});
